<template>
  <validation-observer ref="form" tag="div">
    <confirmation-modal ref="confirmation_modal"></confirmation-modal>
    <div class="py-2 meta-header" style="">
      <div class="row">
        <validation-provider
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('tickets.singular'))"
            class="col-md-6 col-xl-5"
            rules="required"
            vid="ticket_id"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="`${lodash.upperFirst($t('purchase_orders.ticket_id'))}*`"
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <ticket-select-ajax
                :key="`${_uid}-tickets`"
                v-model.number="model.ticketable.ticket_id"
                :disabled="model.id"
                :modify-response="
                (response) => {
                  const {
                    data: { data },
                  } = response;
                  if (data) {
                    let dataEdited = data.filter((datum) => {
                      return (
                        (datum.customer_type === 'brs' &&
                          (!datum.purchase_payment_total ||
                            datum.purchase_order_down_payments > 0)) ||
                        (datum.customer_type === 'lcs' && !datum.trip_total)
                      );
                    });
                    response.data.data = [...dataEdited];
                  }
                  return response;
                }
              "
                :params="{
                status: 'open',
                sort: 'id,desc',
                available_to_add_purchase_order: 1,
                pagination: 'simplePaginate',
                with: 'creator',
              }"
                name="ticket_id"
                @loaded="onTicketLoaded($event)"
                @update:selected="onTicketSelected($event)"
            >
              <template v-slot:beforeList>
                <b-button v-b-modal.ticket-create-modal variant="link"
                >+
                  {{
                    $t("Add new {something}", {
                      something: $t("purchase_orders.ticket_id"),
                    })
                  }}
                </b-button
                >
                <ticket-create-modal
                    id="ticket-create-modal"
                    :key="`ticket-create-modal-${model.ticketable.ticket_id}`"
                    @created="$set(model.ticketable, 'ticket_id', $event.id)"
                ></ticket-create-modal>
              </template>
            </ticket-select-ajax>
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-slot="{ validated, errors }"
            :name="lodash.startCase($t('purchase_orders.partner'))"
            class="col-md-3 col-xl-2"
            rules="required"
            vid="customer_id"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="lodash.startCase($t('purchase_orders.partner')) + '*'"
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <customer-select-ajax
                :key="`${_uid}-customers-${(model.ticketable || {}).ticket_id}`"
                v-model.number="model.customer_id"
                :custom-label="(m) => (m.code ? `${m.name} (${m.code})` : m.name)"
                :disabled="!model.ticketable.ticket_id"
                :params="{ active: 1, type__like_in: `lcs,brs` }"
                :url="`/customers`"
                name="customer_id"
                @loaded="onCustomerLoaded"
                @update:selected="onChangeCustomer"
            >
              <template v-slot:beforeList>
                <b-button v-b-modal.customer-create-modal variant="link"
                >+
                  {{
                    $t("Add new {something}", {
                      something: $t("receipt_orders.customer"),
                    })
                  }}
                </b-button
                >
                <customer-create-modal
                    id="customer-create-modal"
                    :key="
                    `customer-create-modal-${selectedCustomerType}-${model.customer_id}`
                  "
                    :deny-customer-select="true"
                    :initial-value="{
                    type: [(model.ticket || {}).customer_type],
                    registered: false,
                  }"
                    :modal-title="lodash.upperCase($t('customers.create'))"
                    @created="$set(model, 'customer_id', $event.id)"
                ></customer-create-modal>
              </template>
            </customer-select-ajax>
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-slot="{ validated, errors }"
            :name="
            lodash.upperFirst(
              $t(
                (model.ticket || {}).customer_type === 'lcs'
                  ? 'purchase_orders.product_service'
                  : 'purchase_orders.product_service'
              )
            )
          "
            class="col-md-3 col-xl-2"
            rules="required"
            vid="shrimp_id"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :label="
              `${lodash.upperFirst(
                $t(
                  (model.ticket || {}).customer_type === 'lcs'
                    ? 'purchase_orders.product_service'
                    : 'purchase_orders.product_service'
                )
              )}*`
            "
              :state="errors[0] ? false : validated ? true : null"
              class="row mb-3"
              label-cols-md="12"
          >
            <product-select-ajax
                :key="`shrimps-${(model.ticketable || {}).ticket_id}`"
                v-model.number="model.shrimp_id"
                :disabled="shrimpDisabledRules"
                :params="productFetchParameter"
                :placeholder="$t('Choose {something}', {something: $t('products.singular')})"
                name="shrimp_id"
                @loaded="onShrimpLoaded"
                @update:selected="shrimpSelected"
            ></product-select-ajax>
          </b-form-group>
        </validation-provider>
        <template
            v-if="isTicketSelected && isProductSelected && (!['down_payment', 'harvest'].includes(model.type))">
          <div class="col-md-3 col-xl-1">
            <b-form-group
                :label="lodash.upperFirst($t('products.sub_product'))"
                class="row mb-3"
                label-cols-md="12"
            >
              <b-form-input
                  v-model="model.sub_product_name"
                  readonly
              ></b-form-input>
            </b-form-group>
          </div>
          <validation-provider
              v-slot="{ validated, errors }"
              :name="lodash.upperFirst($t('purchase_orders.service_fee'))"
              class="col-md-3 col-xl-2"
              rules="required|min_value:0"
              vid="service_fee"
          >
            <b-form-group
                :invalid-feedback="errors[0]"
                :label="`${lodash.upperFirst($t('margin_per_kg'))}*`"
                :state="errors[0] ? false : validated ? true : null"
                class="row mb-3"
                label-cols-md="12"
            >
              <b-input-group prepend="Rp">
                <numeral-input
                    id="service_fee"
                    v-model="model.service_fee"
                    :placeholder="lodash.upperFirst($t('margin_per_kg'))"
                    :state="errors[0] ? false : validated ? true : null"
                    format="0,0.[00]"
                    lazy-formatter
                    name="service_fee"
                    style="text-align: right"
                    @blur="updateLocalStorage"
                />
              </b-input-group>
            </b-form-group>
          </validation-provider>
        </template>
      </div>
    </div>
    <div v-if="(model.purchase_orders || []).length > 0" class="position-sticky bg-white purchase-order-control">
      <div class="d-flex justify-content-between align-items-center p-16">
        <div class="section-label">{{ lodash.upperCase($t('detail')) }}</div>
        <div>
          <div class="d-flex align-items-center gap-3">
            <b-button variant="primary" @click="addPurchaseOrder">
              {{ lodash.startCase($t('purchase_orders.create_purchase_order')) }}
            </b-button>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div ref="left_arrow" class="page-control left" @click="onPrevClick">
          <svg fill="none" height="10" viewBox="0 0 11 10" width="11" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.41415 1.42247L5.23581 0.244141L0.47998 4.99997L5.23581 9.75581L6.41415 8.57747L2.83665 4.99997L6.41415 1.42247Z"
                fill="currentColor"/>
            <path
                d="M9.40248 0.244141L4.64665 4.99997L9.40248 9.75581L10.5808 8.57747L7.00331 4.99997L10.5808 1.42247L9.40248 0.244141Z"
                fill="currentColor"/>
          </svg>
        </div>
        <div ref="purchase_order_tab" class="purchase-order-tab flex-grow-1 position-relative"
             @scroll="scrollableDisplayHandler">
          <segmented-button
              v-model="segmentedButtons"
              :item-class="(button) => {
            if(button.active){
              return 'paging-item active'
            }
            return 'paging-item'
          }"
              wrapper-class="d-flex segment-wrapper p-0"
          >
          </segmented-button>
        </div>
        <div ref="right_arrow" class="page-control right" @click="onNextClick">
          <svg fill="none" height="10" viewBox="0 0 11 10" width="11" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.75553 1.42454L8.3597 4.99954L4.75553 8.57454L5.92887 9.75788L10.7264 4.99954L5.92887 0.241211L4.75553 1.42454Z"
                fill="currentColor"/>
            <path
                d="M1.7622 0.241211L0.588867 1.42454L4.19303 4.99954L0.588867 8.57454L1.7622 9.75788L6.5597 4.99954L1.7622 0.241211Z"
                fill="currentColor"/>
          </svg>
        </div>
      </div>
    </div>
    <div>
      <template v-for="(purchase_order, key) in model.purchase_orders">
        <validation-observer :ref="`form_purchase_order_${key}`" v-bind:key="purchase_order.bulkKey" tag="div">
          <PurchaseOrderCreateFrom
              v-show="activeTab == key"
              v-model="model.purchase_orders[key]"
              :bulk-index="key"
              :is-km-service="(shrimp_selected || {}).code === 'deposit_goods'"
              @delete="removePurchaseOrder(purchase_order.bulkKey)"
              @input="event => onPurchaseOrderUpdated(key, event)"
          ></PurchaseOrderCreateFrom>
        </validation-observer>
      </template>
    </div>
    <b-modal id="modal-add">
      <template #modal-header="{ close }">
        <div class="heading-font-4">
          <i class="bx bx-info-circle font-size-16 me-2 text-warning"></i>
          Anda akan membuat multiple nota panen
        </div>
      </template>

      <template #default="{ hide }">
        <div class="custom-modal-body">
          <div>
            Apakah {{ $t('products.singular') }} yang Anda pilih sudah benar?
          </div>
          <div>{{ $t('products.singular') }}: <b>{{ shrimp_selected.name }}</b></div>
        </div>
      </template>

      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="md" variant="outline-dark" @click="cancel()">
          Batal
        </b-button>
        <b-button size="md" variant="primary" @click="() => {
          handleAddPurchaseOrder({});
          ok();
        }">
          Lanjutkan
        </b-button>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import {v4 as uuidv4} from 'uuid';
import FormModel from "./model";
import CustomerCreateModal from "@/components/modals/customer-create";
import TicketCreateModal from "@/components/modals/ticket-create";
import TicketSelectAjax from "@/components/inputs/ticket-select-ajax";
import PurchaseOrderCreateFrom from "@/components/forms/purchase_orders/purchase-order-create-form";
import SegmentedButton from "@/components/segmented-button";
import CustomerSelectAjax from "@/components/inputs/customer-select-ajax.vue";
import ConfirmationModal from "@/components/modals/confirmation-modal.vue";
import ProductSelectAjax from "@/components/inputs/product-select-ajax.vue";
// import VueDelayedMultiselectAjax from "@/components/inputs/vue-delayed-multiselect-ajax.vue";
// import VueDelayedMultiselectAjax from "@/components/inputs/vue-delayed-multiselect-ajax.vue";

export default {
  extends: FormModel,
  components: {
    ConfirmationModal,
    CustomerSelectAjax,
    // VueDelayedMultiselectAjax,
    // VueDelayedMultiselectAjax,
    TicketCreateModal,
    CustomerCreateModal,
    ProductSelectAjax,
    TicketSelectAjax,
    PurchaseOrderCreateFrom,
    SegmentedButton
  },
  data() {
    return {
      max_bulk: 20,
      segmentedButtons: [],
      revert_ticket_id: null,
      revert_customer_id: null,
      revert_shrimp_id: null,
      file_accepts: ["image/jpeg", "image/jpg", "image/png", "application/pdf"],
      init: true,
      selectedCustomerType: null,
      quality_options: [
        {value: "fresh", text: "Fresh"},
        {value: "km", text: "Kulit Muda (KM)"},
        {value: "bs", text: "Below Standard (BS)"},
        {value: "us", text: "Under Size (US)"},
        {value: "merah", text: "Merah"},
      ],
      preview: "",
      firstFile: null,
      shrimp_selected: null,
      backupFile: {
        invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
            ? this.value.invoice_document
            : {name: "invoice_document"},
        invoice_documents: !this.lodash.isEmpty(this.value.invoice_documents)
            ? this.value.invoice_documents
            : [],
        operational_cost_document: !this.lodash.isEmpty(
            this.value.operational_cost_document
        )
            ? this.value.operational_cost_document
            : {name: "operational cost document"},
        down_payment_document: !this.lodash.isEmpty(
            this.value.down_payment_document
        )
            ? this.value.down_payment_document
            : {name: "down payment document"},
      },
      model: {
        total: 0,
        service_fee: 0,
        customer_id: null,
        shrimp_id: null,
        farmer_id: null,
        farm_id: null,
        ordered_at: null,
        shrimp_origin: null,
        shrimp_selected: null,
        down_payment: null,
        feed: null,
        ...this.value,
        unit_duration: "days",
        ice_cost:
            this.value?.operational_costs?.find(
                ({name}) => name.toLowerCase() === "ice"
            )?.total || 0,
        shipping_cost:
            this.value?.operational_costs?.find(
                ({name}) => name.toLowerCase() === "delivery"
            )?.total || 0,
        labour_cost:
            this.value?.operational_costs?.find(
                ({name}) => name.toLowerCase() === "labour"
            )?.total || 0,
        files: [
          ...((this.value.files || []).length
              ? this.value.files
              : [
                {name: "invoice document"},
                {name: "down payment document"},
                {name: "operational cost document"},
              ]),
        ],
        purchase_items: [
          ...((this.value.purchase_items || []).length
              ? this.value.purchase_items
              : [
                {
                  fund: "fresh",
                  quality: "fresh",
                },
              ]),
        ],
        purchase_additional_items: [
          ...((this.value.purchase_additional_items || []).length
              ? this.value.purchase_additional_items
              : []),
        ],
        additional_fees: [
          ...((this.value.purchase_additional_fees || []).length
              ? this.value.purchase_additional_fees
              : []),
        ],
        discounts: [
          ...((this.value.purchase_discounts || []).length
              ? this.value.purchase_discounts
              : []),
        ],
        operational_costs: [
          ...(this.value.operational_costs?.length
              ? this.value.operational_costs
              : []),
        ],
        other_operational_costs: [
          ...(this.value.operational_costs?.filter(
              ({name}) =>
                  !["delivery", "labour", "ice"].includes(name.toLowerCase())
          )?.length
              ? this.value.operational_costs?.filter(
                  ({name}) =>
                      !["delivery", "labour", "ice"].includes(name.toLowerCase())
              )
              : []),
        ],
        ticket: !this.lodash.isEmpty(this.value.ticket)
            ? this.value.ticket
            : {},
        ticketable: {
          ...(!this.lodash.isEmpty(this.value.ticketable)
              ? this.value.ticketable
              : {ticket_id: null}),
        },
        invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
            ? this.value.invoice_document
            : {name: "down payment document"},
        invoice_documents: !this.lodash.isEmpty(this.value.invoice_documents)
            ? this.value.invoice_documents
            : [],
        invoice_document_files: [],
        operational_cost_document: !this.lodash.isEmpty(
            this.value.invoice_document
        )
            ? this.value.invoice_document
            : {name: "operational cost document"},
        down_payment_document: !this.lodash.isEmpty(
            this.value.down_payment_document
        )
            ? this.value.down_payment_document
            : {name: "down payment document"},
        down_payment_documents: !this.lodash.isEmpty(
            this.value.down_payment_document
        )
            ? this.value.down_payment_documents
            : [{name: "down payment document"}],
        /** bulk purchase order model */
        purchase_orders: [],
      },
    };
  },
  mounted() {
    window.onbeforeunload = null;
    this.scrollableDisplayHandler();
    let {ticket_id: query_ticket_id} = this.$route.query
    let {ticket_id: local_ticket_id} = JSON.parse(localStorage.getItem('purchase_order')) || {}

    if (query_ticket_id === local_ticket_id) this.retrieveLocalStorage();
    else this.$set(this.model.ticketable, 'ticket_id', query_ticket_id)
    window.addEventListener("resize", () => {
      this.scrollableDisplayHandler();
    });
  },
  watch: {
    model: {
      deep: true,
      handler: function (data) {
        this.$nextTick(() => {
          this.updateLocalStorage(data);
        });
      },
    },
    "model.purchase_items": function (newData) {
      let payload = {...this.model, purchase_items: newData};

      if (this.model?.ticket?.customer_type === "brs") {
        if (!this.model.id)
          localStorage.setItem("purchase_order", JSON.stringify(payload));
      } else {
        // localStorage.removeItem('purchase_order')
      }
    },
    "model.additional_fees": function (newData) {
      let payload = {...this.model, additional_fees: newData};

      if (this.model?.ticket?.customer_type === "brs") {
        localStorage.setItem("purchase_order", JSON.stringify(payload));
      } else {
        // localStorage.removeItem('purchase_order')
      }
    },
    "model.discounts": function (newData) {
      let payload = {...this.model, discounts: newData};
      if (!this.model.id && this.model?.ticket?.customer_type === "brs")
        localStorage.setItem("purchase_order", JSON.stringify(payload));
    },
    "model.ticketable.ticket_id": function (newData, oldData) {
      const hasDraft = !!window.localStorage.getItem("purchase_order_ticket");
      if (
          hasDraft &&
          !this.revert_ticket_id &&
          oldData &&
          oldData !== newData
      ) {
        this.$refs.confirmation_modal.show({
          message: `Data belum tersimpan!<br><br>Apakah Anda yakin untuk mengubah folder?<br>Perubahan input sebelumnya akan direset`,
        }).then((confirmed) => {
          if (confirmed) {
            this.$set(this, "model", {
              purchase_orders: [],
              total: 0,
              service_fee: 0,
              customer_id: null,
              shrimp_id: null,
              farmer_id: null,
              farm_id: null,
              ordered_at: null,
              shrimp_origin: null,
              shrimp_selected: null,
              down_payment: null,
              feed: null,
              unit_duration: "days",
              files: [{}],
              purchase_items: [
                {
                  fund: "fresh",
                  quality: "fresh",
                },
              ],
              purchase_additional_items: [{}],
              additional_fees: [],
              discounts: [],
              other_operational_costs: [
                ...(this.value.operational_costs?.filter(
                    ({name}) =>
                        !["delivery", "labour", "ice"].includes(name.toLowerCase())
                )?.length
                    ? this.value.operational_costs?.filter(
                        ({name}) =>
                            !["delivery", "labour", "ice"].includes(
                                name.toLowerCase()
                            )
                    )
                    : []),
              ],
              ticketable: {ticket_id: this.model.ticketable.ticket_id},
              ticket: {...this.model.ticket},
              invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
                  ? this.value.invoice_document
                  : {name: "invoice_document"},
              invoice_documents: !this.lodash.isEmpty(
                  this.value.invoice_documents
              )
                  ? this.value.invoice_documents
                  : [],
              down_payment_document: !this.lodash.isEmpty(
                  this.value.down_payment_document
              )
                  ? this.value.down_payment_document
                  : {name: "down payment document"},
              operational_cost_document: !this.lodash.isEmpty(
                  this.value.operational_cost_document
              )
                  ? this.value.operational_cost_document
                  : {name: "operational cost document"},
            });
            this.$nextTick(() => {
              this.handleAddPurchaseOrder({
                ticketable: {
                  ticket_id: newData,
                },
              })
              this.renderPagination();
            })
          } else {
            this.revert_ticket_id = oldData;
            this.onTicketLoaded();
          }
        });
        // if (
        //   window.confirm("Data belum tersimpan. Yakin ubah Folder?")
        // ) {
        //   this.resetModel();
        // } else {
        //   this.revert_ticket_id = oldData;
        // }
      } else {
        this.revert_ticket_id = null;
      }
    },
    "model.shrimp_id": async function (newData, oldData) {
      if (newData !== oldData) {
        if (this.revert_shrimp_id) {
          this.revert_shrimp_id = null;
          return;
        }
        let local = localStorage.getItem("purchase_order_ticket");
        if (local) {
          const draft = JSON.parse(local);
          const shrimp_id_draft = draft.shrimp_id;
          if (shrimp_id_draft && shrimp_id_draft === newData.shrimp_id) {
            return;
          }
        }
        if (oldData == null || await this.$refs.confirmation_modal.show({
          message: 'Data belum tersimpan!<br><br>Apakah Anda yakin untuk mengubah ' + this.$t('products.singular') + '?<br>Perubahan input sebelumnya akan direset',
        })) {
          this.model.purchase_orders.forEach((item, index) => {
            this.$set(this.model.purchase_orders[index], "shrimp_id", newData);
            this.$set(this.model.purchase_orders[index], "duration", this.model.duration);
          });
        } else {
          this.revert_shrimp_id = oldData;
          this.onShrimpLoaded();
        }
      }
    },
    "model.customer_id": {
      handler: async function (newData, oldData) {
        if (oldData === null) {
          return;
        }
        if (this.revert_customer_id) {
          this.revert_customer_id = null;
          return;
        }
        let local = localStorage.getItem("purchase_order_ticket");
        if (local) {
          const draft = JSON.parse(local);
          const customer_id_draft = draft.customer_id;
          if (customer_id_draft && customer_id_draft === newData.customer_id) {
            return;
          }
        }
        if (await this.$refs.confirmation_modal.show({
          message: `Data belum tersimpan!<br><br>Apakah Anda yakin untuk mengubah mitra?<br>Perubahan input sebelumnya akan direset`,
        })) {
          this.model.purchase_orders.forEach((item, index) => {
            this.$set(this.model.purchase_orders[index], "customer_id", newData);
          });
        } else {
          this.revert_customer_id = oldData;
          this.onCustomerLoaded();
        }
      }
    },
    "shrimp_selected": function (newData, oldData) {
      if (newData !== oldData) {
        this.model.purchase_orders.forEach((item, index) => {
          this.$set(this.model.purchase_orders[index], "shrimp_selected", newData);
        });
      }
    },
    segmentedButtons: {
      handler: function (newData, oldData) {
        this.scrollableDisplayHandler();
        const isButtonSizeChanged = newData.length !== oldData.length;
        if (isButtonSizeChanged) {
          this.$nextTick(() => {
            // scroll to end
            this.$refs.purchase_order_tab.scrollLeft = this.$refs.purchase_order_tab.scrollWidth;
          })
        }
      },
    },
    "model.purchase_orders": {
      handler: function (newData) {
        this.$emit('model-changed', newData)
        localStorage.setItem('purchase_orders', JSON.stringify(newData));
      },
      deep: true
    },
    "model.ticket": {
      handler(newData) {
        this.model.purchase_orders.forEach((purchase_order) => {
          this.$set(purchase_order, "ticket", newData);
        })
      },
    },
    'model.service_fee': function () {
      this.$set(this.model, 'sub_product_name', this.subProductName)
    }
  },
  computed: {
    subProductName() {
      if (this.model.type === 'hybrid') {
        if (this.model.service_fee <= 500) {
          return 'Basic';
        } else if (500 < this.model.service_fee && this.model.service_fee <= 1000) {
          return 'Pro';
        } else if (this.model.service_fee > 1000) {
          return 'Pro Plus';
        }
      } else if (this.model.type === 'deposit_goods' && this.model.service_fee <= 300) {
        return 'NP';
      }

      return '-';
    },
    isTicketSelected() {
      return !!this.model.ticketable.ticket_id
    },
    isProductSelected() {
      return !!this.model.shrimp_id
    },
    purchaseItemInitialValue() {
      return {
        quality: 'fresh',
        unit_price: this.shrimp_selected.code === 'deposit_goods' ? 0 : null,
      }
    },
    activeTab() {
      return this.segmentedButtons.find((button) => button.active)?.value
    },
    isDownPaymentService() {
      return this.model.type === "down_payment";
    },
    downPaymentDisabledRules() {
      if (this.model.id) {
        if (this.model.payments.length > 0) {
          return true;
        }
      }
      return false;
    },
    shrimpDisabledRules() {
      if (!this.model.ticketable.ticket_id) return true;
      if (this.model.id && this.model.initial_shrimp_id === 13) {
        return false;
      }
      if (!this.model.id) {
        return false;
      }
      return true;
    },
    estimatedHarvestRules() {
      if (this.model.id) {
        const created_at = this.$moment(this.model.created_at).format(
            "YYYY-MM-DD"
        );
        return `required|after_or_equal:${created_at}`;
      }
      return `required|after_or_equal:${this.$moment().format("YYYY-MM-DD")}`;
    },
    orderedAtRules() {
      if (this.model.type === 'down_payment') {
        return `required|after_or_equal:${this.$moment().format("YYYY-MM-DD")}`;
      }
      return `required|before_or_equal:${this.$moment().format("YYYY-MM-DD")}`;
    },
    productFetchParameter() {
      if (this.lodash.isEmpty(this.model.ticket)) {
        return {
          active: 1,
        }
      }
      let parameter = {
        active: 1,
        sort: 'name|asc'
      }
      let folderType = this.model.ticket.customer_type
      if (folderType === 'lcs') {
        parameter.code__not_in = 'hybrid';
      } else parameter.code__in = 'down_payment,hybrid'
      return parameter
    },
    purchaseAdditionalFeeTotal() {
      return this.model.additional_fees
          .filter((item) => item._action !== "delete")
          .reduce((total, item) => total + (item.total || 0), 0);
    },
    purchaseDiscountTotal() {
      return -this.model.discounts
          .filter((item) => item._action !== "delete")
          .reduce((total, item) => total + (item.total || 0), 0);
    },
    purchaseItemTotal() {
      return this.model.purchase_items
          .filter((item) => item._action !== "delete")
          .reduce((total, item) => total + (item.total_price || 0), 0);
    },
    purchaseOrderSubTotal() {
      let iceCost = this.model.ice_cost || 0;
      let shippingCost = this.model.shipping_cost || 0;
      let labourCost = this.model.labour_cost || 0;
      let operationalCostTotal =
          iceCost +
          shippingCost +
          labourCost +
          this.model.other_operational_costs?.reduce(
              (carry, {total}) => carry + (total || 0),
              0
          );

      return this.purchaseOrderTotalPrice + operationalCostTotal;
    },
    purchaseOrderTotalPrice() {
      if (this.isDownPaymentService) return this.model.down_payment;

      let purchaseItemTotal = this.model.purchase_items
          .filter(({_action}) => _action !== "delete")
          .reduce(
              (carry, {quantity, unit_price}) =>
                  carry + (quantity || 0) * (unit_price || 0),
              0
          );
      let additionalFeeTotal = this.model.additional_fees
          .filter(({_action}) => _action !== "delete")
          .reduce((carry, {total}) => carry + (total || 0), 0);
      let discounts = this.model.discounts
          .filter(({_action}) => _action !== "delete")
          .reduce((carry, {total}) => carry + (total || 0), 0);

      return purchaseItemTotal + additionalFeeTotal - discounts;
    },
    purchaseOrderTotalTonase() {
      return this.model.purchase_items
          .filter((purchaseItem) => purchaseItem._action !== "delete")
          .reduce((total, v) => total + (v.quantity || 0), 0);
    },
    ticketCustomerType() {
      return this.model?.ticket?.customer_type?.toLowerCase();
    },
  },
  methods: {
    validateTabs() {
      return Promise.all(
          this.model.purchase_orders?.map(async (_, key) => {
            return this.isTabValid(key);
          })
      );
    },
    resetModel() {
      this.$set(this, "model", {
        purchase_orders: [],
        total: 0,
        service_fee: 0,
        customer_id: null,
        shrimp_id: null,
        farmer_id: null,
        farm_id: null,
        ordered_at: null,
        shrimp_origin: null,
        shrimp_selected: null,
        down_payment: null,
        feed: null,
        unit_duration: "days",
        files: [{}],
        purchase_items: [{...this.purchaseItemInitialValue}],
        purchase_additional_items: [{}],
        additional_fees: [],
        discounts: [],
        other_operational_costs: [
          ...(this.value.operational_costs?.filter(
              ({name}) =>
                  !["delivery", "labour", "ice"].includes(name.toLowerCase())
          )?.length
              ? this.value.operational_costs?.filter(
                  ({name}) =>
                      !["delivery", "labour", "ice"].includes(
                          name.toLowerCase()
                      )
              )
              : []),
        ],
        ticketable: {ticket_id: this.model.ticketable.ticket_id},
        ticket: {...event},
        invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
            ? this.value.invoice_document
            : {name: "invoice_document"},
        invoice_documents: !this.lodash.isEmpty(
            this.value.invoice_documents
        )
            ? this.value.invoice_documents
            : [],
        down_payment_document: !this.lodash.isEmpty(
            this.value.down_payment_document
        )
            ? this.value.down_payment_document
            : {name: "down payment document"},
        operational_cost_document: !this.lodash.isEmpty(
            this.value.operational_cost_document
        )
            ? this.value.operational_cost_document
            : {name: "operational cost document"},
      });
    },
    setActiveTab(value) {
      this.segmentedButtons = this.segmentedButtons.map((button) => {
        button.active = button.value === value;
        return button;
      });
    },
    isTabValid(value) {
      return this.$refs[`form_purchase_order_${value}`][0]
          .validate()
          .then((isValid) => {
            if (!isValid) {
              this.setActiveTab(value);
              this.$nextTick(() => {
                const invalidFeedback = this.$el.querySelector('.invalid-feedback');
                if (invalidFeedback) {
                  invalidFeedback.scrollIntoView({behavior: "smooth", block: "center"});
                  return false;
                }
              })
              return false
            }
            return true
          });
    },
    validateAll() {
      return this.$refs.form.validate().then((isValid) => {
        if (isValid) this.emitValue()
        this.$emit('update:is-valid', isValid)
        this.$emit('update:form-errors', this.$refs.form.errors)
        const invalidFeedback = this.$el.querySelector('.invalid-feedback');
        if (invalidFeedback) {
          invalidFeedback.scrollIntoView({behavior: "smooth", block: "center"});
          return false;
        }
        return isValid;
      }).catch(() => {
        return false;
      }).then(async (isTicketFormValid) => {
        const validated = await this.validateTabs();
        if (!isTicketFormValid) return false;
        return validated.every((isValid) => isValid);
      })
    },
    getPurchaseOrder(index) {
      return {
        get value() {
          return this.model.purchase_orders[index];
        },
        set value(newPurchaseOrder) {
          this.model.purchase_orders[index] = newPurchaseOrder;
        },
      };
    },
    onDeleteFile(file) {
      this.$set(this.model, file, {
        name: file,
        _action: "delete",
      });
    },
    removeFile(key, fileIndex) {
      const filteredFile = this.model?.[key].filter(
          (_, index) => index !== fileIndex
      );
      this.$set(this.model, key, filteredFile);
    },
    // eslint-disable-next-line no-unused-vars
    onTicketLoaded(event) {
      if (this.revert_ticket_id) {
        this.model.ticketable.ticket_id = this.revert_ticket_id;
      }
    },
    onShrimpLoaded() {
      if (this.revert_shrimp_id) {
        this.model.shrimp_id = this.revert_shrimp_id;
      }
    },
    onCustomerLoaded() {
      if (this.revert_customer_id) {
        this.model.customer_id = this.revert_customer_id;
      }
    },
    checkLocalStorage() {
      let local = localStorage.getItem("purchase_order");
      if (local) return;
      if (local && !this.model.id) {
        let jsonData = JSON.parse(local);
        let vm = this;
        this.$set(this, "model", {
          purchase_orders: [],
          total: 0,
          service_fee: 0,
          customer_id: null,
          shrimp_id: null,
          farmer_id: null,
          ordered_at: null,
          shrimp_origin: null,
          shrimp_selected: null,
          down_payment: null,
          feed: null,
          ...jsonData,
          files: jsonData.files.map(function (item) {
            if (Object.keys(item).length)
              return {
                ...item,
                file: vm.dataURLtoFile(item.preview, item.name),
              };
            else return {...item};
          }),
          invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
              ? this.value.invoice_document
              : {name: "invoice_document"},
          invoice_documents: !this.lodash.isEmpty(this.value.invoice_documents)
              ? this.value.invoice_documents
              : [],
          down_payment_document: !this.lodash.isEmpty(
              this.value.down_payment_document
          )
              ? this.value.down_payment_document
              : {name: "down payment document"},
          operational_cost_document: !this.lodash.isEmpty(
              this.value.operational_cost_document
          )
              ? this.value.operational_cost_document
              : {name: "operational cost document"},
        });
      } else {
        // this.init = false
      }
    },
    retrieveLocalStorage() {
      let local = localStorage.getItem("purchase_order_ticket");
      if (local && !this.model.id) {
        let ticketDraft = JSON.parse(local);
        const purchase_orders = ticketDraft.purchase_orders?.map((purchaseOrder) => ({
          purchase_orders: [],
          total: 0,
          service_fee: 0,
          customer_id: null,
          shrimp_id: null,
          farmer_id: null,
          ordered_at: null,
          shrimp_origin: null,
          shrimp_selected: null,
          down_payment: null,
          feed: null,
          ticket: ticketDraft.ticket,
          // ticketable: {
          //   ticket_id: ticketDraft.ticketable?.ticket_id ? parseInt(ticketDraft.ticketable?.ticket_id) : null,
          // },
          ...purchaseOrder,
          // purchase_additional_items: [...purchaseOrder.additional_fees, ...purchaseOrder.discounts],
          additional_fees: purchaseOrder.purchase_additional_items.filter((item) => item.total >= 0),
          discounts: purchaseOrder.purchase_additional_items.filter((item) => item.total < 0),
          invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
              ? this.value.invoice_document
              : {name: "invoice_document"},
          invoice_documents: !this.lodash.isEmpty(this.value.invoice_documents)
              ? this.value.invoice_documents
              : [],
          down_payment_document: !this.lodash.isEmpty(
              this.value.down_payment_document
          )
              ? this.value.down_payment_document
              : {name: "down payment document"},
          operational_cost_document: !this.lodash.isEmpty(
              this.value.operational_cost_document
          )
              ? this.value.operational_cost_document
              : {name: "operational cost document"},
        }))
        ticketDraft.purchase_orders = purchase_orders;
        this.$set(this, 'model', ticketDraft);
        this.$nextTick(() => {
          this.$set(this.model, 'customer_id', 1010)
        })
      } else {
        // this.init = false
      }
      this.renderPagination();
    },
    updateLocalStorage(data) {
      let payload = {...this.model, ...data};
      localStorage.setItem("purchase_order_ticket", JSON.stringify(payload));
    },
    onTicketSelected(event) {
      if (this.revert_ticket_id) {
        return null;
      }
      // if(event){
      //   this.$set(this.model, "ticket", event);
      // }
      if (event) {
        this.$set(this.model, "ticket", event);

      }
    },
    shrimpSelected(payload) {
      if (this.revert_shrimp_id) return null;
      if (!this.lodash.isEmpty(payload)) {
        this.$set(this.model, 'type', payload.code)
        this.$emit("shrimp-changed", payload)
        this.model.service_fee = payload.fee;
        this.$set(this.model, "shrimp_id", payload && payload.id);
        this.$set(this, "shrimp_selected", payload);
        if (this.model.id) return null;
        if (this.model?.ticket?.customer_type === "brs") {
          this.$set(this.model, "duration", payload.duration || 0);
        }
        if (payload.type === 'deposit_goods') {
          this.model.purchase_orders?.forEach((purchaseOrder) => {
            purchaseOrder.purchase_items?.forEach((purchaseItem) => {
              this.$set(purchaseItem, "unit_price", 0);
              this.$set(purchaseItem, "total_price", 0);
            })
          })
        }
        if (!this.model.id) {
          // this.model.purchase_orders.map((purchaseOrder) => {
          //   if (payload.code === "down_payment") {
          //     this.$set(purchaseOrder, "purchase_items", [{}]);
          //     this.$set(purchaseOrder, "additional_fees", []);
          //     this.$set(purchaseOrder, "discounts", []);
          //   } else {
          //     this.$set(purchaseOrder, "down_payment", null);
          //   }
          // });
        }
      } else {
        this.model.service_fee = 0;
        this.model.duration = 0;
      }
      if (this.model?.purchase_orders?.length === 0) {
        this.addPurchaseOrder({
          ticketable: {
            ticket_id: event.id
          },
        })
      }
      this.setPurchaseOrderTotal();
    },
    parterSelected(payload) {
      if (!this.lodash.isEmpty(payload)) {
        this.$set(
            this.model.payment,
            "from_bank_account_id",
            payload && payload?.id
        );
      } else {
        this.model.partner_id = null;
      }
    },
    addPurchaseItem() {
      this.model.purchase_items.push({...this.purchaseItemInitialValue});
    },
    addOtherOperationalCost(val) {
      this.model.other_operational_costs?.push({...val});
    },
    removeOtherOperationalCost(index) {
      this.model.other_operational_costs?.splice(index, 1);
    },
    addItem(key, val) {
      this.model[key].push({
        ...this.purchaseItemInitialValue,
        ...val,
      });
      this.setPurchaseOrderTotal();
    },
    undeletedItems(key) {
      return this.model[key].filter((r) => r._action !== "delete");
    },
    removeItem(key, index) {
      const items = this.undeletedItems(key);
      if ((items[index] || {}).id) {
        // this.$set(this.model[key][index], '_action', 'delete')
        items[index]._action = "delete";
      } else {
        // this.model[key].splice(index, 1)
        items.splice(index, 1);
      }
      this.model[key] = items;
      this.setPurchaseOrderTotal();
    },
    dataURLtoFile(dataUrl, filename) {
      if (!dataUrl) return;
      let arr = dataUrl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    onChangeAdditionalFeeTotal() {
      this.setPurchaseOrderTotal();
      this.updateLocalStorage();
    },
    onChangeDiscountTotal() {
      this.setPurchaseOrderTotal();
      this.updateLocalStorage();
    },
    onFileChange(key, file) {
      let vm = this;
      let reader = new FileReader();
      let data = null;
      // if file its a file object
      if (file instanceof File) {
        data = file;
      } else {
        file.target.files[0];
      }
      if (!data) {
        setTimeout(function () {
          vm.model[key] = {...vm.backupFile[key]};
          return null;
        }, 1000);
      }
      if (this.file_accepts.includes(data.type)) {
        reader.readAsDataURL(data);
        reader.onload = () => {
          this.$set(this.model[key], "preview", reader.result);
          this.$set(this.model[key], "extension", data.type);
          this.$set(this.backupFile, key, {...this.model[key]});
        };
      }
    },
    addFile(key, file, index) {
      this.model[key].push({});
      if (!index) {
        index = this.model[key].length - 1;
      }
      let vm = this;
      let reader = new FileReader();
      let data = null;
      // if file its a file object
      if (file instanceof File) {
        data = file;
      } else {
        file.target.files[0];
      }
      if (!data) {
        setTimeout(function () {
          vm.model[key][index] = {...vm.backupFile[key]};
          return null;
        }, 1000);
      }
      if (this.file_accepts.includes(data.type)) {
        reader.readAsDataURL(data);
        reader.onload = () => {
          this.$set(this.model[key][index], "preview", reader.result);
          this.$set(this.model[key][index], "extension", data.type);
          this.$set(this.model[key][index], "file", data);
          this.$set(this.backupFile, key, {...this.model[key][index]});
        };
      }
    },
    onChangePurchaseItemQuantity(purchaseItem) {
      this.setPurchaseItemTotalPrice(purchaseItem);
      this.setPurchaseOrderTotal();
      this.updateLocalStorage();
    },
    onChangePurchaseItemUnitPrice(purchaseItem) {
      this.setPurchaseItemTotalPrice(purchaseItem);
      this.setPurchaseOrderTotal();
      this.updateLocalStorage();
    },
    setPurchaseItemTotalPrice(purchaseItem) {
      this.$set(
          purchaseItem,
          "total_price",
          (purchaseItem.quantity || 0) * (purchaseItem.unit_price || 0)
      );
    },
    setPurchaseOrderTotal() {
      this.$set(
          this.model,
          "total",
          this.purchaseItemTotal +
          this.purchaseAdditionalFeeTotal +
          this.purchaseDiscountTotal || 0
      );
    },
    onFarmerSelected() {
      this.model.farm_id = null;
    },
    addPurchaseOrder(additionalValues) {
      this.validateTabs().then((validatedFields) => {
        const isValid = validatedFields.every((r) => r) || this.model.purchase_orders.length === 0;
        if (isValid) {
          if (this.model.purchase_orders.length + 1 > this.max_bulk) {
            return this.$toast(`Maksimal ${this.max_bulk} nota!`, {
              type: "warning",
              icon: {
                iconClass: "mdi mdi-alert toast-icon text-warning",
              },
              timeout: 10000,
            });
          }
          if (this.model.purchase_orders.length === 1) {
            this.$bvModal.show('modal-add')
            return;
          }
          this.handleAddPurchaseOrder(additionalValues);
        }
      })
    },
    handleAddPurchaseOrder(additionalValues) {
      const purchaseOrder = {
        bulkKey: uuidv4(),
        ticketable: this.model.ticketable,
        customer_id: this.model.customer_id,
        odoo_vendor_id: this.model.customer.odoo_partner_id,
        shrimp_id: this.model.shrimp_id,
        shrimp_selected: this.shrimp_selected,
        type: this.model.type,
        duration: null,
        total: 0,
        service_fee: 0,
        farmer_id: null,
        farm_id: null,
        ordered_at: null,
        shrimp_origin: null,
        down_payment: null,
        feed: null,
        unit_duration: "days",
        ice_cost:
            this.value?.operational_costs?.find(
                ({name}) => name.toLowerCase() === "ice"
            )?.total || 0,
        shipping_cost:
            this.value?.operational_costs?.find(
                ({name}) => name.toLowerCase() === "delivery"
            )?.total || 0,
        labour_cost:
            this.value?.operational_costs?.find(
                ({name}) => name.toLowerCase() === "labour"
            )?.total || 0,
        files: [
          ...((this.value.files || []).length
              ? this.value.files
              : [
                {name: "invoice document"},
                {name: "down payment document"},
                {name: "operational cost document"},
              ]),
        ],
        purchase_items: [
          ...((this.value.purchase_items || []).length
              ? this.value.purchase_items
              : [{...this.purchaseItemInitialValue}]),
        ],
        purchase_additional_items: [
          ...((this.value.purchase_additional_items || []).length
              ? this.value.purchase_additional_items
              : []),
        ],
        additional_fees: [
          ...((this.value.purchase_additional_fees || []).length
              ? this.value.purchase_additional_fees
              : []),
        ],
        discounts: [
          ...((this.value.purchase_discounts || []).length
              ? this.value.purchase_discounts
              : []),
        ],
        operational_costs: [
          ...(this.value.operational_costs?.length
              ? this.value.operational_costs
              : []),
        ],
        other_operational_costs: [
          ...(this.value.operational_costs?.filter(
              ({name}) =>
                  !["delivery", "labour", "ice"].includes(name.toLowerCase())
          )?.length
              ? this.value.operational_costs?.filter(
                  ({name}) =>
                      !["delivery", "labour", "ice"].includes(name.toLowerCase())
              )
              : []),
        ],
        ticket: !this.lodash.isEmpty(this.model.ticket)
            ? this.model.ticket
            : {},
        invoice_document: !this.lodash.isEmpty(this.value.invoice_document)
            ? this.value.invoice_document
            : {name: "down payment document"},
        invoice_documents: !this.lodash.isEmpty(this.value.invoice_documents)
            ? this.value.invoice_documents
            : [],
        invoice_document_files: [],
        operational_cost_document: !this.lodash.isEmpty(
            this.value.invoice_document
        )
            ? this.value.invoice_document
            : {name: "operational cost document"},
        down_payment_document: !this.lodash.isEmpty(
            this.value.down_payment_document
        )
            ? this.value.down_payment_document
            : {name: "down payment document"},
        down_payment_documents: !this.lodash.isEmpty(
            this.value.down_payment_document
        )
            ? this.value.down_payment_documents
            : [{name: "down payment document"}],
        ...additionalValues,
      };
      this.$set(this.model.purchase_orders, this.model.purchase_orders.length, purchaseOrder);
      this.renderPagination();
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
    removePurchaseOrder(bulkKey) {
      this.model.purchase_orders = this.model.purchase_orders.filter((purchaseOrder) => purchaseOrder.bulkKey !== bulkKey)
      this.renderPagination()
    },
    onPurchaseOrderUpdated(key, event) {
      this.$set(this.model.purchase_orders, key, event)
      this.$nextTick(() => {
        this.updateLocalStorage()
      })
    },
    renderPagination() {
      const buttons = Array(this.model.purchase_orders.length).fill(0).map((_, index) => ({
        value: index, text: index + 1, props: {
          block: true
        }
      }));
      if (buttons.length > 0) {
        buttons[buttons.length - 1].active = true;
      }
      this.$set(this, 'segmentedButtons', buttons)
      // this.segmentedbuttons = buttons;
    },
    scrollableDisplayHandler() {
      const hasScrollableContent = this.$refs.purchase_order_tab?.scrollWidth > this.$refs.purchase_order_tab?.clientWidth;
      this.$refs.right_arrow?.classList?.remove('active')
      this.$refs.left_arrow?.classList?.remove('active')
      if (hasScrollableContent) {
        if (this.$refs.purchase_order_tab?.scrollLeft > 0) {
          this.$refs.left_arrow?.classList?.add('active')
        }
        if (this.$refs.purchase_order_tab?.scrollLeft < this.$refs.purchase_order_tab?.scrollWidth - this.$refs.purchase_order_tab?.clientWidth) {
          this.$refs.right_arrow?.classList?.add('active')
        }
      }
    },
    onNextClick() {
      this.$refs.purchase_order_tab.scrollLeft += (60 * 4);
    },
    onPrevClick() {
      this.$refs.purchase_order_tab.scrollLeft -= (60 * 4);
    },
    onChangeCustomer(event) {
      this.model.customer = event
    }
  },
};
</script>

<style>
.purchase-order-card-form .card-title:first-child {
  text-transform: uppercase;
}
</style>

<style lang="scss" scoped>

.delete-item {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.empty-state {
  color: #acaebd;
}

.section-label {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0084f3;
}

.page-title {
  font-weight: 800;
  font-size: 12px;
  color: #6c7589;
}

.button-remove-item {
  color: #f14250 !important;
}

.card-body {
  padding: 0 !important;
}
</style>


<style lang="scss" scoped>
::v-deep {
  .paging-item {
    // width: 32px;
    // height: 32px;
    border-radius: 4px;
  }

  .card-body {
    padding: 0 !important;
  }


  .purchase-order-tab {
    border-bottom: solid 1px #DADADA;
    height: 34px;
    position: absolute;
    max-width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      display: none;
    }

    .segment-wrapper {
      background: none;
      scroll-snap-type: x mandatory;

      .paging-item {
        scroll-snap-align: center;
        width: 60px;
        min-width: 60px;

        .active {
          background: #DADADA;
        }

        button {
          border-radius: 0;
        }

        button.active {
          font-weight: 700;
          font-size: 14px;
          line-height: 16px;
          color: #363637 !important;
          background: #F8F9FA;
          border: solid 1px #DADADA;
          border-bottom: 0;
        }

        button:not(.active) {
          font-weight: 700;
          font-size: 14px;
          line-height: 16px;
          color: #ACAEBD !important;
          border-bottom: solid 1px #DADADA;
          background: white;
        }

        button:focus {
          outline: none;
          box-shadow: none;
        }

        button:hover {
          background: #EEF3F7;
        }
      }
    }
  }

  .paging-item {

  }

}

.page-control {
  min-width: 60px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-bottom: solid 1px #DADADA;

  .active {
    color: #ACAEBD;
  }

  &:not(.active) {
    color: #E6E6E6;
  }
}
</style>

<style lang="scss">
.purchase-order-card-form {
  position: relative;

  .card-body {
    padding: 0 !important;

    .card-title.clearfix {
      padding: 16px 16px 0 16px !important
    }
  }

  .meta-header {
    padding: 0 16px !important;
  }

  .purchase-order-control {
    border-block: solid #F8F9FA 4px;
    border-bottom: 0;
    top: 68px;
    z-index: 9;
    box-shadow: 0px 4px 8px 0px #0000000D;
    //padding: 16px !important;
  }

  .footer-wrapper {
    padding: 16px !important;
  }
}

::v-deep {
  .icon-warning {
    color: #FFD130 !important;
  }
}

.heading-font-4 {
  font-size: 16px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: 0.32px;
}

</style>

<style lang="scss">
.custom-modal-body {
  color: var(--neutral-gray-800, #454646);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
</style>